export default __webpack_public_path__ + "static/media/img9.144d63c7.PNG";